/* eslint-disable */
import { permissionsMessages } from '@ringcentral-integration/commons/enums/permissionsMessages';
export default {
  [permissionsMessages.callingDisable]:
    'You don’t have permissions to place outbound calls. Please contact your {brand} account administrator for an upgrade.',
} as const;

// @key: @#@"[permissionsMessages.callingDisable]"@#@ @source: @#@"You don't have permissions to place outbound calls. Please contact your {brand} account administrator for an upgrade."@#@
